import "./main.css";
import "./navigation";
import AuthButton from "./components/AuthButton.svelte";
import CookieConsentPopup from "./components/CookieConsentPopup.svelte";
import {checkCookieConsent, loadGTag} from "./gtag";

new AuthButton({target: document.getElementById("auth")!});

if (checkCookieConsent()) {
	loadGTag();
} else {
	new CookieConsentPopup({target: document.getElementById("cookie-consent-popup")!});
}

(function () {
	const style= document.createElement("link");
	style.rel = "stylesheet";
	style.href = "/static/lib/highlight/styles/default.min.css";
	document.head.appendChild(style);
	const script = document.createElement("script");
	script.src = "/static/lib/highlight/highlight.min.js";
	script.onload = () => window.hljs.highlightAll();
	document.body.append(script);
})();
